export const allLanguages = [
  { label: 'English', value: 'English' },
  { label: 'Spanish', value: 'Spanish' },
  { label: 'French', value: 'French' },
  { label: 'German', value: 'German' },
  { label: 'Chinese', value: 'Chinese' },
  { label: 'Hindi', value: 'Hindi' },
  { label: 'Arabic', value: 'Arabic' },
  { label: 'Portuguese', value: 'Portuguese' },
  { label: 'Russian', value: 'Russian' },
  { label: 'Japanese', value: 'Japanese' },
  { label: 'Korean', value: 'Korean' },
  { label: 'Italian', value: 'Italian' },
  { label: 'Dutch', value: 'Dutch' },
  { label: 'Swedish', value: 'Swedish' },
  { label: 'Norwegian', value: 'Norwegian' },
  { label: 'Danish', value: 'Danish' },
  { label: 'Finnish', value: 'Finnish' },
  { label: 'Turkish', value: 'Turkish' },
  { label: 'Thai', value: 'Thai' },
  { label: 'Vietnamese', value: 'Vietnamese' },
  { label: 'Urdu', value: 'Urdu' },
  { label: 'Bengali', value: 'Bengali' },
  { label: 'Punjabi', value: 'Punjabi' },
  { label: 'Gujarati', value: 'Gujarati' },
  { label: 'Tamil', value: 'Tamil' },
  { label: 'Telugu', value: 'Telugu' },
  { label: 'Malayalam', value: 'Malayalam' },
  { label: 'Kannada', value: 'Kannada' },
  { label: 'Marathi', value: 'Marathi' },
  { label: 'Persian', value: 'Persian' },
  { label: 'Hebrew', value: 'Hebrew' },
  { label: 'Greek', value: 'Greek' },
  { label: 'Czech', value: 'Czech' },
  { label: 'Polish', value: 'Polish' },
  { label: 'Hungarian', value: 'Hungarian' },
  { label: 'Romanian', value: 'Romanian' },
  { label: 'Ukrainian', value: 'Ukrainian' },
  { label: 'Afrikaans', value: 'Afrikaans' },
  { label: 'Swahili', value: 'Swahili' },
  { label: 'Zulu', value: 'Zulu' },
  { label: 'Amharic', value: 'Amharic' },
  { label: 'Tagalog', value: 'Tagalog' },
  { label: 'Malay', value: 'Malay' },
  { label: 'Indonesian', value: 'Indonesian' },
  { label: 'Pashto', value: 'Pashto' },
  { label: 'Sinhalese', value: 'Sinhalese' },
  { label: 'Nepali', value: 'Nepali' },
  { label: 'Burmese', value: 'Burmese' },
  { label: 'Khmer', value: 'Khmer' },
  { label: 'Lao', value: 'Lao' },
];
